module.exports = __webpack_public_path__ + "static/media/Students.7ed0333e.png";